/* BEGIN CUSTOMIZATION: Sankalp-codex - Variant family available sizes opens outfit sidebar */
import * as NextSkyTheme from "@NextSkyTheme/global";
import { eventModal } from "@NextSkyTheme/modal";

const TRIGGER_SELECTOR = ".product-available-sizes-trigger";
const TEMPLATE_SELECTOR = "template.variant-family-popup-template";
const MODAL_SELECTOR = "outfit-popup.variant-family-popup-modal";

document.addEventListener("click", (event) => {
  const trigger = event.target.closest(TRIGGER_SELECTOR);
  if (!trigger) return;

  event.preventDefault();

  const cardProduct = trigger.closest(".product-item");
  const template = cardProduct?.querySelector(TEMPLATE_SELECTOR);
  if (!template?.content?.firstElementChild) return;

  const existingModal = document.querySelector(MODAL_SELECTOR);
  if (existingModal) existingModal.remove();

  const wrapper = document.createElement("div");
  wrapper.appendChild(template.content.firstElementChild.cloneNode(true));

  const modal = wrapper.querySelector("outfit-popup");
  if (!modal) return;

  NextSkyTheme.getBody().appendChild(modal);
  setTimeout(() => eventModal(modal, "open", true), 80);
  NextSkyTheme.global.rootToFocus = trigger;
});
/* END CUSTOMIZATION: Sankalp-codex - Variant family available sizes opens outfit sidebar */
